import { Tab } from "@mui/material";

export const MuiTab = Tab;
